import { createAsyncThunk } from "@reduxjs/toolkit";
import { connection, log } from "./shared";

export const additionalInformationUpdated = createAsyncThunk<
  void,
  { roomId: string; byRequestId: Record<string, Record<string, unknown>> },
  { rejectValue: string }
>(
  "signalr/additionalInformationUpdated",
  async ({ roomId, byRequestId }, { rejectWithValue }) => {
    if (!connection) {
      log("additionalInformationUpdated: no active connection", { roomId });
      return rejectWithValue("Connection not established");
    }
    try {
      log(
        "additionalInformationUpdated: invoking UpdateRoomWithAdditionalInformation",
        {
          roomId,
          byRequestId,
        },
      );
      await connection.invoke(
        "UpdateRoomWithAdditionalInformation",
        `workflow:${roomId}`,
        byRequestId,
      );
      log("additionalInformationUpdated: invoke success", { roomId });
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : String(e);
      log("additionalInformationUpdated: ERROR", { roomId, message });
      return rejectWithValue(
        message || `Failed to send additional information update`,
      );
    }
  },
);
